import getAnswerService from "./util/getAnswerService";
import { $ } from './util/jq';

const setBank = () => {
  const appkey = 'customerAffiliate';
  let bank = 'empty';

  let _getQueryVariable = (variable) => {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return (false);
  };

  let _saveBank = (name) => {
    let isRedirecting = false;
    getAnswerService().then((answerService) => {
      answerService.saveAnswer({
        appkey:     appkey,
        value:      name,
        timestamp:  new Date()
      }).then(() => {
        const uuid = ignite.getUserInfo('uuid');
        const pathIndex = 0;
        const isLandingPage = window.location.pathname === "/guide";
        bank = _getQueryVariable("bank");

        if( isLandingPage && bank ) {
          isRedirecting = true;
          console.log('Redirecting to entry path', ' / bank: ', bank);
          window.location.href = `${window.location.origin}/guide/${uuid}/${pathIndex}/0?bank=${bank}`;
        }
      }).then(() => {
        assignGuideBankSettings(name, isRedirecting);
      });
    });
  };

  if (_getQueryVariable("bank")) {
    bank = _getQueryVariable("bank");
    _saveBank(bank);
  } else {
    $('#contentWrapper.landing').removeClass('d-none');
    $('body').removeClass('loading-data');
    getAnswerService().then((answerService) => {
      answerService.getAnswer(appkey).then((result) => {
        if(result.value && result.value[0]) {
          bank = result.value[0];
          _saveBank(bank);
        } else {
          bank = 'empty';
          assignGuideBankSettings();
          $("html").removeClass("hidden");
        }
      });
    });
  }
};

const setBankBasedOnBranch = () => {
  window.ignite.getAnswer('aaaClientBranchId').then((result) => {
    if(result.value && result.value[0]) {
      if( result.value.includes("2016019") ||
        result.value.includes("2005") ||
        result.value.includes("2006") ||
        result.value.includes("2001") ||
        result.value.includes("2004") ||
        result.value.includes("2003") ||
        result.value.includes("2002")
      ) {
        return true;
      }
    }
  });
  return false;
};

const assignGuideBankSettings = (bank, isRedirecting) => {
  const $html = $("html");
  $html.attr("data-bank", bank);
  if (!isRedirecting) $html.removeClass("hidden");
  if (bank === "jefferson" || bank === "02") {
    $("title").text("Jefferson Bank Guide");
    $("#favicon").attr("href","/classpath/assets/images/favicon-jefferson.png");
    $("#favicon-shortcut").attr("href","/classpath/assets/images/favicon-jefferson.png");
    $html.addClass("jeffersonBank");
  } else {
    $('title').text('Central Bank Guide');
    $("#favicon").attr("href","/classpath/assets/images/favicon.png");
    $("#favicon-shortcut").attr("href","/classpath/assets/images/favicon.png");
  }
};

export default function centralDelivery() {
  setBank();
}



// WEBPACK FOOTER //
// ./src/main/js/centralDelivery.js